var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 208,
    viewBox: "0 0 208 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104 16C55.3989 16 16 55.3989 16 104C16 152.601 55.3989 192 104 192C152.601 192 192 152.601 192 104C192 55.3989 152.601 16 104 16ZM0 104C0 46.5624 46.5624 0 104 0C161.438 0 208 46.5624 208 104C208 161.438 161.438 208 104 208C46.5624 208 0 161.438 0 104ZM88 96C88 91.5817 91.5817 88 96 88H104C108.418 88 112 91.5817 112 96V144C116.418 144 120 147.582 120 152C120 156.418 116.418 160 112 160H104C99.5817 160 96 156.418 96 152V104C91.5817 104 88 100.418 88 96ZM102 72C108.627 72 114 66.6274 114 60C114 53.3726 108.627 48 102 48C95.3726 48 90 53.3726 90 60C90 66.6274 95.3726 72 102 72Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSm);
export default __webpack_public_path__ + "static/media/info-sm.f98c186f.svg";
export { ForwardRef as ReactComponent };